var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggler",class:{ 'toggler--active': _vm.value },on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', ! _vm.value)}}},[_c('span',{staticClass:"toggler__inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }